document.addEventListener("DOMContentLoaded", function() {
  const track = document.querySelector(".carousel-track");
  const dots = document.querySelectorAll(".carousel-indicator");

  if (window.innerWidth <= 768 && dots.length > 0) {
    let index = 0;

    dots.forEach(dot => {
      dot.addEventListener("click", () => {
        index = parseInt(dot.dataset.slide);
        track.style.transform = `translateX(-${index * 100}%)`;
        updateDots();
      });
    });

    function updateDots() {
      dots.forEach((dot, i) => {
        dot.classList.toggle("dot-active", i === index);
      });
    }
  }
});